import React from "react";

import { checkStatus, emailDeveloper } from "../../../api";
import Track from "../../../track";
class StepVerification extends React.Component {
  state = {
    developerEmail: "",
    appStatus: "building",
    errMessage: "",
    successMessage: "",
    assetlinks_url:'',
    emailDeveloperLoading: false,
    formValues:{},
  };
  componentDidMount() {
    this.checkStatus();
  }
  skipAndDownload = ()=>{
    Track.event({
      category: "PWA2APK",
      action: "Click",
      label:"skipAndDownload"
    });
    this.props.history.push("/pwa-to-apk/download/" + this.props.match.params.appId );
  }

  handleChange = e => {
    this.setState({ developerEmail: e.target.value });
  };
  handleEmailDeveloper = e => {
    if (this.state.developerEmail === "")
      return this.setState({
        errMessage: "Please provide an email"
      });
      Track.event({
        category: "PWA2APK",
        action: "Click",
        label:"Email developer"
      });
    this.setState({
      emailDeveloperLoading: true,
      errMessage: ""
    });
    emailDeveloper({
      email: this.state.developerEmail,
      id: this.props.match.params.appId
    })
      .then(response => {
        this.setState({
          successMessage: "Email send successfully",
          emailDeveloperLoading: false
        });
      })
      .catch(err => {
        this.setState({
          errMessage: err.message,
          emailDeveloperLoading: false
        });
      });
  };
  checkStatus = () => {
    checkStatus({ id: this.props.match.params.appId }).then(data => {
      if (data.status) {
        if (data.build_status)
          this.setState({
            appStatus: "ready-to-download",
            assetlinks_url:data.assetlinks_url,
            formValues:data
          });
        else {
          setTimeout(() => {
            this.checkStatus();
          }, 5000);
        }
      } else {
        this.setState({ loading: false, errMessage: data.error });
      }
    });
  };
  render() {
    return (
      <div className="step-verify col-sm-12 m-auto">
        <h3>Verification</h3>
        {this.state.appStatus === "ready-to-download" ? <h6 className="mb-4">Read and follow instructions</h6> :'' }
        {this.state.appStatus === "building" ? (
          <div className="app-verify text-center">
            <img
              alt="Loading"
              src="https://storage.googleapis.com/appilder_cdn/wordpress-theme/pwa-apk/images/apploader-optimised.gif"
              className="w-25"
            />
            <h6 className="mb-4 mt-4">Please wait until app is generated</h6>
          </div>
        ) : (
          ""
        )}
        {this.state.appStatus === "ready-to-download" ? (
          <div className="app-verify text-center">
            <p className="text-left">
              <strong>Step: 1 </strong> Download Assetlinks.json by clicking
              button below.
            </p>
            <p className="text-left">
              <strong>Step: 2 </strong> Upload Assetlinks.json file to
              .well-known/ directory(Publically accessible).
            </p>
            <p className="text-left">
              <strong>Step: 3 </strong> Make sure
              https://www.example.com/.well-known/assetlinks.json is accessible
            </p>
            <p className="text-left">
            (If this step is not properly configured, the chrome url bar will be shown in the app)
            </p>
            <a
              className="btn btn-dark text-white mt-3 mb-5"
              href={this.state.assetlinks_url}>
              <i className="fas fa-download mr-2 ml-2" /> Download File</a>
            {this.state.errMessage ? (
              <div className="alert alert-danger" role="alert">
                {this.state.errMessage}
              </div>
            ) : (
              ""
            )}
            {this.state.successMessage ? (
              <div className="alert alert-success" role="alert">
                {this.state.successMessage}
              </div>
            ) : (
              ""
            )}
            <h6 className="text-left">
              Email these Instructions to your Developer:
            </h6>
            <div className="input-group">
              <input
                type="email"
                className="form-control"
                onChange={this.handleChange}
                name="email"
                placeholder="Email Id"
              />
              <div className="input-group-append">
                <button
                  type="submit"
                  className="btn btn-secondary"
                  onClick={this.handleEmailDeveloper}
                >
                  {this.state.emailDeveloperLoading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    <i className="fas fa-arrow-right" />
                  )}
                </button>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {this.state.appStatus === "ready-to-download" ? (
          <button
            className="btn btn-success w-100"
            onClick={this.skipAndDownload}
          >
            Skip and Download APK
          </button>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default StepVerification;
